import { render } from "./CreateMessage.vue?vue&type=template&id=035e582a"
import script from "./CreateMessage.vue?vue&type=script&lang=js"
export * from "./CreateMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__